import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const StarIconFilled = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
                 isFilled={true}
        >{'\ue838'}</MuiIcon>
    );
}
